import { pieAttributeMappings } from 'app/area/reports/containers/chart/components/attributes/constants';
import { FavouriteLayoutTypeContext } from 'app/components/favourite-layout/constants';
import { FavouriteLayoutAttributes } from 'app/types-shared';

const layoutAttributeExist = (layoutAttributes: FavouriteLayoutAttributes[], layoutType: number, layoutTypeContext: number, name: string) =>
  layoutAttributes.some(attr =>
    attr.layoutTypeId === layoutType &&
    attr.layoutTypeContext === layoutTypeContext &&
    attr.name === name
  );

/**
 * Returns dictionary of layout attributes for selected report (from definition), layoutType and layoutTypeContext.
 * It also adds matching attributes with layoutTypeContext === 1.
 * 
 * @param definition Favourite definition
 * @param layoutType 
 * @param layoutTypeContext 
 */
export const getFavouriteLayoutAttributes = (
  layoutAttributes: FavouriteLayoutAttributes[],
  layoutType: number,
  layoutTypeContext: number
) => {

  const defaultAttrForPie = layoutType === 4 && layoutTypeContext !== FavouriteLayoutTypeContext.Dashboard ?
    { [pieAttributeMappings.hideDatalabelsOnDashboards]: false } : {};

  const attr = !!layoutAttributes && layoutAttributes
    .filter(a => a.layoutTypeId === layoutType && (a.layoutTypeContext === FavouriteLayoutTypeContext.SelectionReport
      || (a.layoutTypeContext === layoutTypeContext && !layoutAttributeExist(layoutAttributes, layoutType, 1, a.name))
      || (a.name === pieAttributeMappings.hideDatalabelsOnDashboards && layoutTypeContext === FavouriteLayoutTypeContext.Dashboard )))
    .reduce((result, a) => {
      result[a.name] = a.value;
      return result;
    }, {} as { [key: string]: string | boolean });

  return !!attr && Object.keys(attr).length > 0
    ? { ...defaultAttrForPie, ...attr }
    : defaultAttrForPie;
};

export const getFavouriteLayoutAttributeOptions = (
  layoutAttributes: FavouriteLayoutAttributes[],
  layoutType: number,
  layoutTypeContext: number
) => {

  const attr = !!layoutAttributes && layoutAttributes
    .filter(a => a.layoutTypeId === layoutType && (a.layoutTypeContext === 1
      || (a.layoutTypeContext === layoutTypeContext && !layoutAttributeExist(layoutAttributes, layoutType, 1, a.name))
      || a.name === pieAttributeMappings.hideDatalabelsOnDashboards))
    .reduce((result, a) => {
      result[a.name] = a.value;
      return result;
    }, {} as { [key: string]: string | boolean });

  return !!attr && Object.keys(attr).length > 0
    ? attr
    : undefined;
};
